module.exports = __webpack_public_path__ + "img/lusail.f24b79c1.svg";